module.exports = __webpack_public_path__ + "img/notification-icon.2bd58ba2.svg";